import { LoadingDots } from './LoadingDots'

export function AiChatConnectingOverlay() {
  return (
    <div className='absolute inset-0 z-10 flex flex-col items-center justify-center bg-pure-white'>
      <div className='-translate-y-20 flex flex-col items-center'>
        <div className='my-4 scale-[1.5]'>
          <LoadingDots className='justify-center' />
        </div>
        <span className='mt-1 text-[18px] text-medium-dark-gray'>Connecting to agent...</span>
      </div>
    </div>
  )
}
